/* Shared ticket-status metadata + badge, used by the Tickets page and the
   kiosk editor's "Problems" tab. Colors are design tokens (STYLING.md). */

interface StatusStyle {
  label: string;
  /** muted background token */
  bg: string;
  /** foreground/text token */
  fg: string;
}

/** Ticket status id → label + token-based colors. */
export const TICKET_STATUS_STYLES: Record<number, StatusStyle> = {
  0: { label: "New", bg: "var(--color-error-muted)", fg: "var(--color-error)" },
  1: { label: "Open", bg: "var(--color-info-muted)", fg: "var(--color-info)" },
  2: { label: "Monitoring", bg: "var(--color-warning-muted)", fg: "var(--color-warning)" },
  3: { label: "AutoGenerated", bg: "var(--color-info-muted)", fg: "var(--color-info)" },
  4: { label: "Closed", bg: "var(--color-success-muted)", fg: "var(--color-success)" },
};

const FALLBACK: StatusStyle = { label: "", bg: "var(--color-bg-muted)", fg: "var(--color-text-secondary)" };

function styleFor(statusId: number): StatusStyle {
  const s = TICKET_STATUS_STYLES[statusId];
  return s ?? { ...FALLBACK, label: `Status ${statusId}` };
}

/** Colored pill for a ticket status id. */
export function statusBadge(statusId: number) {
  const s = styleFor(statusId);
  return (
    <span
      style={{
        padding: "2px 8px",
        borderRadius: "var(--radius-1)",
        fontSize: "var(--text-xs)",
        background: s.bg,
        color: s.fg,
        fontWeight: 600,
      }}
    >
      {s.label}
    </span>
  );
}
